var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',_vm._b({staticClass:"infra-icons",attrs:{"src":_vm.infraIcons[_vm.infraAT],"rounded":"0"}},'b-img',_vm.thumbnailProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }